import React from 'react';
import { steps } from '../data/gymklar';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-167" data-mp="7svdaescvutl">
      <div className="mx-auto max-w-6xl" data-id="element-168" data-mp="3pyrp50ha6wc5">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-169" data-mp="3pzt8rtcd4r5h">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-170" data-mp="3tzjydtq5l18f">
            Slik fungerer <em className="text-red-700" data-id="element-171" data-mp="lkthqcb4h2jf">LØPEKLAR™</em>
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-172" data-mp="qjmnfik63p91">
            Fra kjøp til samlingsplassen: klar til neste fellestrening på fem minutter.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-3 lg:gap-8" data-id="element-173" data-mp="gsrww1zw23hs">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-174" data-mp="14iw1abkwi79u" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-175" data-mp="19ae2n0qu69vc">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-176" data-mp="2rlxon2p7ky4m">
                <span className="sr-only" data-id="element-177" data-mp="2mo5yad47pk2j">Steg {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-178" data-mp="31csfkkdeglwe">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-179" data-mp="2wixvhftvu4ws">
          Kjøp → last ned → skriv ut → ut og løp. Enkelt og strukturert.
        </p>
      </div>
    </section>;
}